export default "__VITE_ASSET__rva7$rSb__"